// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36nVm","fullView":"styles_fullView__1UXTB"};